var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.9993 0L12.9993 27","stroke":"white","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M25 16.5049L13 28.5049L1 16.5049","stroke":"white","strokeWidth":"2","key":1})]);
}

Arrow.defaultProps = {"viewBox":"0 0 26 30","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
